import { IconDashboard, IconCalendar } from './sidebarIcons';
import Sidebar from '../components/SidebarNext';
import { hasFunctionAccess } from '../permissionConfig';

const NAV_BASE = [
    { to: '/sales', label: 'Sales Dashboard', icon: <IconDashboard />, end: true, functionKey: 'dashboard' },
    { to: '/sales/festive-season-trends', label: 'Festive Season Trends', icon: <IconCalendar />, functionKey: 'festive_season_trends' },
];

export default function SalesLayout({ user, onLogout, children }) {
    const navItems = NAV_BASE.map(item => ({ ...item, locked: !hasFunctionAccess(user, 'sales', item.functionKey) }));
    return (
        <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: '#FAF8FC' }}>
            <Sidebar navItems={navItems} sectionLabel="Sales" homeHref="/landing" user={user} domainKey="sales" />
            <div id="sbn-main" className="sbn-content"
                 style={{ flex: 1, minWidth: 0, padding: '28px 32px', overflowY: 'auto', height: '100%' }}>
                {children}
            </div>
        </div>
    );
}
